<style>
  .menu_item{
    font-size: 15px;
    font-weight: 600;
    margin-bottom: 0px;
    display: inline-block;
    cursor: pointer;
    color: #fff;
  }
  .menu_options_sub{
    display: none;
    width: 100%;
    height: auto;
    position: absolute;
    top: 55px;
    background-image: linear-gradient(#fff,#D3D3D3);
    color:#000000;
  }
  .mlink a{
    text-decoration: none;
    color:#000000;
  }
  .mlink{
    padding-top: 4px;
    padding-bottom: 6px;
    border-bottom: 1px dotted #bdbdbd;
  }
  .active{
    color:#4b8cbb!important;
  }
  tr:hover{
    background-color: transparent;
  }
  .topheadv1{
    padding-bottom: 5px;
    cursor: pointer;
    font-size: 14px;
  }
  .menu_options_mn{
    height: 100%;
    vertical-align: middle;
    line-height: 3;
    margin-left: 45px;
  }
  .menu_data{
    text-align: left;
    height: 100%;
    border: 1px solid #bdbdbd;
    font-family: Roboto, Arial, sans-serif;
    color: #424242;
    font-size: 13px;
    font-weight: 500;
  }
.table {
  width: 100%;
  height:100%;
  max-width: 100%;
  margin-bottom: 1rem;
  background-color: transparent;
}
.table td{
  border: none;
}
.dropdown-toggle::after{
  border-top: 0.3em solid #fff;
}
.app-header.navbar .dropdown-menu{
  top: 42px;
}
.app-header.navbar .navbar-brand,.app-header.navbar{
  background-color: #4b8cbb;
}
.navbar-nav .nav-link.active,.navbar .navbar-nav .active.dropdown-toggle:hover,{
  color: #fff!important;
}
</style>
<template>
<header class="app-header navbar">
  <b-link class="navbar-brand" to="dashboard" v-if="userrole==3"></b-link>
  <b-link class="navbar-brand" to="admindashboard" v-if="userrole!=3"></b-link>
  <div class="menu_options_mn" v-if="userrole!=3">
    <p class="menu_item">Actions &nbsp;<i class="fa fa-angle-down"></i></p>
  </div>
  <div class="menu_options_sub">
    <table class="table table-responsive">
        <tbody>
          <tr>
            <td style="margin-left:20px" class="menu_data" >
              <div v-if="data.submenu.length==0" v-for="data in navItem">
              <div class="mlink " v-if="data.ismenu==true">
                  <a @click="itemlink" v-bind:href="'#'+data.url"><i v-bind:class="data.purl"></i> {{data.mainmenu}}</a>
              </div>
            </div>
            </td>
            <td class="menu_data" v-for="data in navItem">
              <div v-if="data.submenu.length>0 && data.ismenu==true">
              <div  class="topheadv1" ><b><i v-bind:class="data.purl"></i> {{data.mainmenu}}</b></div>
              <div v-for="submenu in data.submenu">
                <div class="mlink" v-if="submenu.ismenu==true">
                  <a @click="itemlink"  v-bind:href="'#'+submenu.url" v-if="submenu.ismenu==true"><i v-bind:class="submenu.purl"></i> {{submenu.mainmenu}}</a>
                </div>
              </div>
            </div>
            </td>
          </tr>
        </tbody>
      </table>
  </div>
  <b-nav is-nav-bar class="ml-auto" style="margin-right:1%;">
    <b-nav-item-dropdown right>
      <template slot="button-content">
          <img src="static/img/avatars/default-img.png" class="img-avatar" alt="admin@bootstrapmaster.com">
          <span class="d-md-down-none" style="color: #fff !important">{{username}}</span>
        </template>
      <b-dropdown-item @click="changepassword"><i class="fa fa-lock"></i> Change Password</b-dropdown-item>
      <b-dropdown-item @click="logout"><i class="fa fa-sign-out"></i> Logout</b-dropdown-item>
    </b-nav-item-dropdown>
  </b-nav>
</header>
</template>
<script>
import apiUrl from '../constants';
import CryptoJS from 'crypto-js';
import axios from 'axios';
export default {
  name: 'header',
  data() {
    return {
      username: '',
      usertype: '',
      userrole:'',
      logindata: [],
      navItem:[]
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes  = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail =JSON.parse(plaintext);
    this.usertype = userdetail.utype;
    this.username = userdetail.FirstName;
    this.userrole = userdetail.roleid;
    this.userid = userdetail.userid;
    //console.log("userdetail",userdetail);

    var permissionEncrypt = window.localStorage.getItem('permissiondata')
    var bytes1  = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
    var plaintext1 = bytes1.toString(CryptoJS.enc.Utf8);
    this.navItem=JSON.parse(plaintext1);

    this.$nextTick(() => {
      $(document).ready(function(){
      $(".menu_options_mn").on("mouseover",function(){
        $(".menu_options_sub").slideDown("slow");
      });
      $(".menu_options_sub").on("mouseleave", function(){
        $(this).slideUp("slow");
      });
      $("a").click(function(){
   $("a.active").removeClass("active");
   $(this).addClass("active");
});
    });
      })
  },
  methods: {
    sidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },

    logout(e) {
      e.preventDefault()
      localStorage.removeItem('permissiondata')
      localStorage.removeItem('userdetail')
      localStorage.removeItem('userToken')
      localStorage.removeItem('isLoggedIn')
      window.localStorage.removeItem("LSPermission")
      window.localStorage.removeItem("LSUsername")
      window.localStorage.removeItem("LSHub")
      window.localStorage.removeItem("LSHubId")
      window.localStorage.removeItem("LSMobile")
      window.localStorage.removeItem("LSStatus")
      window.localStorage.removeItem("LSEmail")
      window.localStorage.removeItem("LSUtype")
      window.localStorage.removeItem("LSProjectId")
      window.localStorage.removeItem("LSRole")
      window.localStorage.removeItem("LSProjectName")
      window.localStorage.removeItem("LSProject")
      window.localStorage.removeItem("encryPassword")
      this.centralisedLoggedOut();
      //this.$router.push('/login')
    },
     changepassword() {
        this.$router.push('/changepassword')
    },
    sidebarMinimize(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle(e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    itemlink(){
       $(".menu_options_sub").slideUp("slow");
    },
    centralisedLoggedOut(){
      this.input = {
        userid: this.userid
      };
      axios({
        method: "POST",
        url: apiUrl.api_url + "centralisedLoggedOut",
        data: this.input
        }).then((response) => {
          if(response.data.code ==200)
          {
            this.$router.push('/login');
          }
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Header.vue?0142242f